<template>
  <div>
    <div v-if="!is_loading" class="columns">
      <div class="column is-4-tablet is-3-desktop">
        <package-card :title="subscriptionType.name" :cost="subscriptionType.amount" :package-type="packageTypeForCard"></package-card>
        <a :href="invoice_url" class="button is-button-blue-outline is-button-medium is-fullwidth margin-top-20">DOWNLOAD INVOICE</a>
      </div>
      <div class="column is-6-desktop is-8-tablet">
        <!-- EFT -->
        <div v-if="isEftView" class="payment-method">
          <div class="title is-size-4">{{eft_payment_title}}</div>
          <span class="info-display is-size-6">{{eft_payment_subtitle}}</span>
          <div class="columns is-mobile is-vcentered is-marginless is-paddingless">
            <div class="column is-fullwidth is-marginless is-paddingless" v-for="details in eft_hp_banking_details">
              <!-- payment info -->
              <table class="table is-fullwidth is-full-mobile eft-table">
                <tr v-for="(value, key) in details">
                  <td>{{key}}</td>
                  <th>{{value}}</th>
                </tr>
                <tr>
                  <td colspan="2" v-html="proof_of_payment_to">
                  </td>
                </tr>
              </table>
              <hr>
              <table class="table is-fullwidth eft-table">
                <tr>
                  <td>{{amount_exc_vat_copy}}</td>
                  <th>R{{amount_exc_vat}}</th>
                </tr>
                <tr>
                  <td>{{vat_copy}}</td>
                  <th>{{vat_name}}</th>
                </tr>
                <tr>
                  <td>{{total_amount_copy}}</td>
                  <th>R{{amount_inc_vat}}</th>
                </tr>
                <tr>
                  <td colspan="2">
                    <button
                            class="button is-button-blue is-button-large is-pulled-right"
                            @click.prevent="redirectToRenew()">OK
                    </button>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <!-- CREDIT CARD -->
        <div v-if="!isEftView" class="payment-method">
          <div class="title is-size-4">{{cc_payment_title}}</div>
          <div v-if="showSpinner">
            <div class="column is-12 is-margin-top-40">
              <p class="has-text-centered">
                <img src="/static/img/spinner.svg" alt="Verifying payment..." />
              </p>
            </div>
          </div>
          <div v-if="!showSpinner" class="columns is-vcentered is-marginless is-paddingless">
            <div class="column is-hidden-mobile">
              <div class="column is-display-contents" v-for="method in card_payment_types">
                <input type="radio" :id="method.value" :value="method.value" v-model="form.card_type"/>
                <label :for="method" class="margin-right-30">&nbsp;{{ method.name }}</label>
              </div>
            </div>
            <div class="column is-mobile is-hidden-tablet is-hidden-desktop is-hidden-widescreen" v-for="method in card_payment_types">
              <input type="radio" :id="method.value" :value="method.value" v-model="form.card_type"/>
              <label :for="method">&nbsp;{{ method.name }}</label>
            </div>
          </div>
          <div v-if="!showSpinner" class="columns is-mobile">
            <div class="column is-12 is-margin-top-40">
              <div v-for="credit_card in credit_card_information">
                <div v-for="section in credit_card">
                  <div class="control">
                    <div v-for="(element, index) in section" class="field" v-if="section[index].type === 'text'">
                      <input
                              :ref="`${section[index].element_name}`"
                              class="input"
                              type="text"
                              v-model="form[`${section[index].element_name}`]"
                              :name="`${section[index].element_name}`"
                              :placeholder="`${section[index].name}`">
                    </div>
                    <div class="field" v-else>
                      <div>
                        <span class="info-display is-size-6 margin-top-10">{{section[index].name}}</span>
                      </div>
                      <div v-if="section[index].type === 'dropdown'">
                        <drop-down
                                :dropdownName="`${section[index].element_name}`"
                                place-holder=""
                                v-on:changed="creditCardDropDownChanged($event, section[index].element_name)"
                                :items="section[index].elements"
                                :select-first-item-on-mount="true"
                                :is-full-width="true"
                                v-model="form[`${section[index].element_name}`]"></drop-down>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="columns is-mobile margin-top-20 inner-margin">
            <div class="column is-half padleft10">Subtotal (ex VAT)</div>
            <div class="column is-half has-text-right padright10">R{{ amount_exc_vat }}</div>
          </div>
          <div class="columns is-mobile inner-margin">
            <div class="column is-half padleft10">Plus (VAT)</div>
            <div class="column is-half has-text-right padright10">R{{ vat_amount }}</div>
          </div>
          <div class="columns is-mobile inner-margin grey-back inner-margin">
            <div class="column is-half has-text-weight-bold padleft10">Total (incl. VAT)</div>
            <div class="column is-half has-text-weight-bold has-text-right padright10">R{{ amount_inc_vat }}</div>
          </div>
          <div v-if="!showSpinner" class="columns margin-top-20">
            <div class="column is-marginless">
              <div class="has-text-right-desktop has-text-right-tablet"></div>
            </div>
            <div class="column is-marginless">
              <div class="has-text-right-desktop has-text-right-tablet">
                <button
                        class="button is-button-blue is-fullwidth"
                        :class="[{ 'is-loading': is_sending}]"
                        @click.prevent="submitCreditCard()"
                        :disabled="!canSubmitCreditCard">MAKE PAYMENT
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <form id="forwardToRenewGateway" class="is-invisible" name="forwardToRenewGateway" v-if="redirectParams.length > 0" method="post" :action="redirectAction" target="_self">
      <p>Please have your phone ready to obtain a One Time Pin</p>
      <input v-for="param in redirectParams" :name="param.name" :value="param.value" type="hidden" />
      <input type="submit" class="button is-button-blue is-button-medium has-text-weight-bold is-size-6 is-fullwidth" value="Click here to continue" />
    </form>
  </div>
</template>
<script>
  /* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */

  import axios from 'axios'
  import PackageCard from './../card/PackageCard.vue'
  import DropDown from './../../components/DropDown.vue'
  import ApiResource from './../../api/ApiResource.js'
  import OnboardingPackageForms from './../../mixins/onboarding-package-forms.js'

  export default {
    metaInfo: {
      title: 'Business Portal | Hellopeter - Renew your subscription (payment)'
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Renew your subscription (payment)'
      })
    },
    name: 'RenewPackagePaymentDetails',
    components: {
      PackageCard,
      DropDown
    },
    mixins: [OnboardingPackageForms],
    props: {
      paymentType: {
        type: String
      },
      invoiceReference: {
        type: String
      }
    },
    data () {
      return {
        redirectParams: [],
        redirectAction: '',
        showSpinner: false,
        is_sending: false,
        is_loading: false,
        invoice_url: '',
        invoice: '',
        amount_inc_vat: '',
        amount_exc_vat: '',
        vat_amount: '',
        vat_name: '',
        subscriptionType: {
          name: '',
          package_name: '',
          amount: ''
        },
        form: new ApiResource({
          card_owner: '',
          card_number: '',
          card_month: '',
          card_year: '',
          card_cvc: '',
          card_type: 'visa',
          card_return_url: '',
          card_amount: 0.00
        })
      }
    },
    computed: {
      isEftView () {
        return this.paymentType === 'eft'
      },
      canSubmitCreditCard () {
        return this.form.card_cvc.length > 0 && this.form.card_year.length > 0 && this.form.card_month.length > 0 && this.form.card_owner.length > 0 && this.form.card_number.length > 0 && this.form.card_type.length > 0
      },
      packageTypeForCard () {
        const selectedPackage = this.subscriptionType.package_name.substr(0, 3).toLowerCase()
        if (selectedPackage === 'pro') {
          return 'pro'
        } else if (selectedPackage === 'ent') {
          return 'enterprise'
        }
        return 'lite'
      }
    },
    created () {
      this.is_loading = true
      axios.get(`/invoices/${this.invoiceReference}/amounts`)
        .then(({data}) => {
          this.is_loading = false
          this.amount_exc_vat = data.amount_exc_vat
          this.amount_inc_vat = data.amount_inc_vat
          this.invoice = data.invoice
          this.invoice_url = `${process.env.API_URL}/invoices/${data.invoice.id}/file`
          this.eft_hp_banking_details[0]['Your reference'] = data.invoice.payment_reference
          this.vat_amount = data.vat_amount
          this.vat_name = data.vat_percent_applied
          this.subscriptionType.name = data.subscriptionType.name
          this.subscriptionType.amount = `R${this.amount_exc_vat}`
          this.subscriptionType.package_name = this.subscriptionType.name.toLowerCase()

          if (this.$route.query['id'] !== undefined) {
            // we landed her most probably as a result of a redirect from a credit card payment
            this.showCreditCardProcessing()
          }
        })
        .catch((error) => {
          this.is_loading = false
          console.log('error', error)
        })
    },
    methods: {
      redirectToRenew () {
        flash('Thank you for renewing your subscription. Your package information will be updated when your EFT payment is processed', 'is-success', false)
        this.$router.push('/billing-details')
      },
      creditCardDropDownChanged (selection, elementName) {
        this.form[elementName] = selection.value
      },
      submitCreditCard () {
        this.is_sending = true
        const invoiceId = this.invoice.id

        const currentRoute = this.$route.path
        this.form.card_return_url = location.origin + currentRoute
        if (!currentRoute.endsWith('/')) {
          this.form.card_return_url += '/'
        }

        const yearBeforeSubmit = this.form.card_year
        const monthBeforeSubmit = this.form.card_month
        this.form.send(`/billing/${invoiceId}/credit-card-payment`)
          .then((response) => {
            if (typeof response.payment.redirect !== 'undefined' && typeof response.payment.redirect.parameters !== 'undefined') {
              this.redirectParams = response.payment.redirect.parameters
              this.redirectAction = response.payment.redirect.url
              setTimeout(() => {
                document.getElementById('forwardToRenewGateway').submit()
              }, 500)
            } else {
              if (typeof response.payment.result.message !== 'undefined') {
                flash(response.payment.result.message, 'is-danger', false)
              } else if (typeof response.payment.result.description !== 'undefined') {
                flash(response.payment.result.description, 'is-danger', false)
              }

              if (this.form.card_year === '') {
                this.form.card_year = yearBeforeSubmit
              }
              if (this.form.card_month === '') {
                this.form.card_month = monthBeforeSubmit
              }
            }
            this.is_sending = false
          })
          .catch(() => {
            this.is_sending = false
          })
      },
      showCreditCardProcessing () {
        this.showSpinner = true
        this.form.card_type = 'visa'

        const paymentToken = this.$route.query['id']
        const verifyTokenUrl = `/billing/verify-credit-card-payment/${this.invoice.id}/${paymentToken}`

        axios.get(verifyTokenUrl)
          .then((response) => {
            this.showSpinner = false
            if (response.data.paymentVerification.payment_successful) {
              flash('You have successfully renewed your package', 'is-success', false)
              this.$router.push('/billing-details')
            } else {
              const errorMessage = response.data.paymentVerification.result.description
              flash(errorMessage, 'is-danger', false)
            }
          })
          .catch(() => {
            this.showSpinner = false
          })
      }
    }
  }
</script>
<style scoped>
  table td, table th{
    border:none;
    padding-left: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/billing/RenewPackagePaymentDetails.vue